<ng-container>
  <form class="k-form k-form-md" [formGroup]="form" #formControl>

    <div>{{flow?.displayName}}</div>

    <kendo-formfield>
      <div class="k-checkbox-wrap">
        <kendo-switch formControlName="monitor" #monitor></kendo-switch>&nbsp;
        <label class="ml-2 text-sm text-gray-700" [for]="monitor">Monitoring this flow</label>
      </div>
    </kendo-formfield>

    <kendo-formfield>
      <div class="k-checkbox-wrap">
        <kendo-switch formControlName="notifyOnFail" #notifyFail></kendo-switch>&nbsp;
        <label class="ml-2 text-sm text-gray-700" [for]="notifyFail">Notify if Flow Failed</label>
      </div>
    </kendo-formfield>

    <div style="display: flex; align-items: center; gap: 8px;">
      <kendo-formfield>
        <div class="k-checkbox-wrap">
          <kendo-switch formControlName="notifyOnMissed" #notifyOnMissed></kendo-switch>&nbsp;
          <label class="ml-2 text-sm text-gray-700" [for]="notifyOnMissed">{{ form.get('notifyOnMissed')?.value ? 'Notify if Flow did not run for' : 'Notify if Flow did not run for number of days' }}</label>
        </div>
      </kendo-formfield>

      @if (form.get('notifyOnMissed')?.value) {
        <kendo-formfield>
          <div class="k-checkbox-wrap">
            <kendo-numerictextbox formControlName="missingDays" [min]="1"
              [format]="'n0'"
              [size]="'small'"
              [rounded]="'small'"
              style="width:70px; margin-right:6px;"
              [spinners]="false"
              #missingDays
              >
            </kendo-numerictextbox>
            <label class="ml-2 text-sm text-gray-700" [for]="missingDays">of days</label>
          </div>
        </kendo-formfield>
      }
    </div>

    <kendo-formfield>
      <label class="block text-sm font-medium text-gray-700 mb-1" [for]="email">Email To</label>
      <input kendoTextBox #email type="text" formControlName="email"
        >
      </kendo-formfield>
    </form>
    @if (!this.flow) {
      <div class="loading">
        <div class="k-i-loading"></div>
      </div>
    }
    <kendo-dialog-actions>
      <kendo-button (click)="onSave()" themeColor="primary" [disabled]="form.pristine || form.invalid">Save</kendo-button>
      <kendo-button (click)="onCancel()">Cancel</kendo-button>
    </kendo-dialog-actions>

  </ng-container>
